export default class TeamMembers {
    constructor() {
        this.teamBios = document.querySelectorAll('.open-bio');
        this.teamBios && this.teamBios.forEach((personBio)=>{
            personBio.addEventListener("click", (event) => {
                this.openBio(personBio);
            });
        })

        if (window.innerWidth < 768) {
            this.teamMembers = document.querySelectorAll('.b-team__team .team-name');
            this.teamMembers && this.teamMembers.forEach((teamGroup)=>{
                teamGroup.addEventListener("click", (event) => {
                    this.openTeam(teamGroup);
                });
            })
        }
    }

    openBio(bioButton) {
        let bioToOpen = bioButton.nextElementSibling;
        bioToOpen.style.display = bioToOpen.style.display === 'none' ? 'block' : 'none';
    }

    openTeam(openButton) {
        let teamToOpen = openButton.nextElementSibling;
        teamToOpen.style.display = teamToOpen.style.display === 'none' ? 'grid' : 'none';

        if(teamToOpen.style.display === 'none') {
            openButton.classList.remove("team-name--open");
        } else {
            openButton.classList.add("team-name--open");
        }
    }
}